import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5rem;
  padding: 5rem;
  box-sizing: border-box;
  max-width: 100%;
`;


export const DescriptionBox = styled.div`
  display: flex;
  flex: 1 1 45%;
  min-width: 300px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  h1 {
    margin-bottom: 2rem;
    font-size: 2.3rem;
    font-weight: 500;
    color: var(--first-color);
    overflow-wrap: break-word;
  }

  p {
    font-size: 1rem;
    color: var(--text-color);
    line-height: 1.6;
    overflow-wrap: break-word;
    text-align: justify;
  }
`;

export const CardBox = styled.div`
  display: flex;
  flex: 1 1 45%;
  min-width: 300px;
  box-sizing: border-box;
  flex-direction: column;

  h1 {
    margin-bottom: 5rem;
    font-size: 2.3rem;
    font-weight: 500;
    color: var(--first-color);
  }
`;


export const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  gap: 5rem;
`;


export const IconBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  width:12rem;
  
  h2{
    font-size: 2rem;
    font-weight: 500;
    color: var(--first-color);
  }
  img {
      width: 10rem;
    }
    `;

export const PhotoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f2f7f1  ;
  padding: 5rem;
  align-items: center;

  h1 {
    margin-bottom: 5rem;
    font-size: 2.3rem;
    font-weight: 500;
    color: var(--first-color);
  }
`;

export const PhotoWiring = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10rem;
`;

export const Card = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 15px 30px rgba(0,0,0,0.2);
  }

  img {
    width: 18.75rem;
    height: 30rem;
    object-fit: cover;
    border-radius: 1rem;
    display: block;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0);
    transition: background 0.3s ease;
  }

  &:hover::after {
    background: rgba(0,0,0,0.2);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease;
    color: #fff;
    width: 2rem;
    height: 2rem;
  }

  &:hover svg {
    opacity: 1;
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 2rem;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 80vw;
  max-height: 80vh;

  img {
    display: block; 
    width: 80vw;           
    height: auto;       
    max-height: 80vh;   
    object-fit: cover;
    border-radius: 0.5rem;
  }

  button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: rgba(0,0,0,0.5);
    border: none;
    border-radius: 50%;
    color: #fff;
    padding: 0.5rem;
    cursor: pointer;

    &:hover {
      background: rgba(0,0,0,0.7);
    }

    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;